
//used for filter, load more click, and product recommendation section
function rebindCartEvents() {

// <------------------------ Open Ajax cart -------------------->

// product page frequently bought toghether product script
 $(".frequently-btn").off("click").on("click", function () {
   const item = $(this);
   var upselID = $(this).attr("data-id");
   const sQty = parseInt($(item).attr('data-qty'));

  var get_data = {
    items: [
      {
        quantity: 1,
        id: upselID
      }
    ]
  };

  // ------------- AJAX code for adding to cart -----------
  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data: get_data,
    success: function (data) {

      // Emit event to update the cart (Reformation theme might use these events)
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: data } }));
        $(item).attr('data-qty',(sQty - 1));
        console.log('sQty ',sQty);
        $("#refresh-cart").trigger("click"); 
      
      // Call function to open AJAX cart
      setTimeout(function () {
       updateAjaxCart();
       }, 400);
      // Fetch latest cart data and trigger refresh event
      // setTimeout(function () {
      //   $.getJSON('/cart.js', function (cart) {
      //     let cartData = cart.items;
      //     document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: cartData }));
      //   });
      // }, 100);         
      
    },
    error: function (error) {
      // console.error('Error adding to cart:', error);
      // console.log(error);          
      
    }
  });
});

// Function to open and refresh AJAX cart
function updateAjaxCart() {

  const ajaxCart = document.getElementById('Cart-Drawer');
  if (ajaxCart) {
    ajaxCart.classList.add('active'); // Open the cart drawer
    document.dispatchEvent(new Event('cart:updated')); // Reformation theme cart refresh event
  } else {
    console.log('AJAX cart not found.');
  }
}


$(document).off("click", "#refresh-cart").on("click", "#refresh-cart", function () {
  $.getJSON('/cart.js', function (cart) {

    // Dispatch event to update the cart UI
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

    // Update cart count (modify the selector if your theme uses a different one)
    $(".thb-item-count").text(cart.item_count);

    // Optional: Force reload cart content inside the drawer
    reloadCartDrawer(cart);
  });
});

// Function to force reload cart content inside the cart drawer
function reloadCartDrawer(cart) {
  $("#Cart-Drawer").load(location.href + " #Cart-Drawer > *", function () {
  });
}

// <------------------------ End Ajax cart -------------------->

}


// ajax cart
rebindCartEvents();




// index page review slider
$('.review-slider').slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



// index page winter-poster-slider
$('.winter-poster-slider').slick({
  infinite: true,
  dots: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1
});


// index page products-collection-slider
// $('.index-products-collection-slider').slick({
//   dots: true,
//   arrows: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 4,
//   slidesToScroll: 2, 
//   prevArrow: '<div class="slick-prev"><svg width="23" height="40" viewBox="0 0 23 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33333 3L20 20L3.33333 37" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
//   nextArrow: '<div class="slick-next"><svg width="23" height="40" viewBox="0 0 23 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.6667 3L3 20L19.6667 37" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>', 
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 2,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1.3,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });
function initProductSlider() {
  $('.index-products-collection-slider').each(function() {
    var $slider = $(this);
    
    // Destroy existing slider if it exists
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    
    // Initialize slider
    $slider.slick({
      dots: true,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 2,
      prevArrow: '<div class="slick-prev"><svg width="23" height="40" viewBox="0 0 23 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33333 3L20 20L3.33333 37" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      nextArrow: '<div class="slick-next"><svg width="23" height="40" viewBox="0 0 23 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.6667 3L3 20L19.6667 37" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.3,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
}

// Initialize on page load
$(document).ready(function() {
  initProductSlider();
});

// Reinitialize when theme editor changes the section
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  $(document).on('shopify:section:load', function(event) {
    setTimeout(function() {
      initProductSlider();
    }, 10);
  });
}


// index page learn-slider
$('.learn-slider').slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1.2,
  slidesToScroll: 1,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
       
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.vdo-btn-click').click(function(){
  $(this).parent().parent(".thumb-btn-wrap").hide().addClass("vid-is-show");
  $(this).parent().parent().siblings(".vdo-sec").children("#vdo-play").trigger('play');
});



//faq page  and product page tab script
  $(".cmn-tab").click(function(){
      // tab menu active class add
       $(this).addClass("active");
       $(this).siblings().removeClass("active");

       // tab content active class add
       let tabId = $(this).attr("data-id");

        $(this).parent().next().children().each(function(){
           let TabcontId = $(this).attr("data-id");
            if (tabId == TabcontId){
               $(this).show();
               $(this).addClass("active");
               $(this).siblings().hide();
               $(this).siblings().removeClass("active");
            }          
        });
       
    });

    
  $(".faq-heading").click(function () {
    $(this).parent(".faq-block-items").toggleClass("active");
    $(this).next(".faq-text").slideToggle();
     $(this).parent(".faq-block-items").siblings().removeClass("active");
     $(this).parent(".faq-block-items").siblings().find(".faq-text").slideUp();
  });



// product page product image load more script
//  $(function() {
//   $(".cus-product-image").slice(0, 4).show(); // select the first ten
//   $("#load").hide();
//   if ($(".cus-product-image").length > 4) { 
//       $("#load").show();
//     }
//   $("#load").click(function(e) { // click event for load more
//     e.preventDefault();
//     $(".cus-product-image:hidden").slice(0, 4).show(); // select next 10 hidden divs and show them
//     if ($(".cus-product-image:hidden").length == 0) { // check if any hidden divs still exist
//       $("#load").hide();
//     }
//   });
// });

// product page product image load more script
$(function() {
  const $productSlider = $('#Product-Slider');
  const desktopLoadMore = $productSlider.attr('data-desktop-load-more') === 'true';
  const mobileLimit = $productSlider.attr('data-mobile-limit');
  
  function getInitialCount() {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      if (mobileLimit === 'all') {
        return $(".cus-product-image").length;
      } else {
        return parseInt(mobileLimit) || 4;
      }
    } else {
      if (!desktopLoadMore) {
        return $(".cus-product-image").length;
      } else {
        return 4;
      }
    }
  }

  function updateImages() {
    const initialCount = getInitialCount();
    $(".cus-product-image").hide().slice(0, initialCount).show();
    if ($(".cus-product-image:hidden").length === 0) {
      $("#load").hide();
    } else {
      $("#load").show();
    }
  }

  // Initial setup
  updateImages();

  $("#load").off('click').on('click', function(e) {
    e.preventDefault();
    $(".cus-product-image:hidden").slice(0, 4).show();
    if ($(".cus-product-image:hidden").length === 0) {
      $("#load").hide();
    }
  });

  // Responsive update without reload
  let resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      updateImages();
    }, 250);
  });
});


// Place wishlist and quality feature button in same alignment
$(function () {
  function placeWishlistBeforeQualityFeature() {
    var $qualityBtn = $('.qualityFeatureMdl').first();
    var $wishlistBtn = $('.swym-wishlist-button-bar').first();

    if ($qualityBtn.length && $wishlistBtn.length && !$wishlistBtn.next('.qualityFeatureMdl').length) {
      // Create flex container if not already present
      var $flexDiv = $('<div class="wishlist-quality-flex"></div>').css({
        display: 'flex',
        gap: '12px',
        alignItems: 'center'
      });

      // Insert flex container before quality button
      $qualityBtn.before($flexDiv);

      $flexDiv.append($wishlistBtn);
      $flexDiv.append($qualityBtn);
    }
  }

  placeWishlistBeforeQualityFeature();

  // Observe DOM changes for dynamic loading (Swym)
  var observer = new MutationObserver(function () {
    placeWishlistBeforeQualityFeature();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});






// Collection page 
let Colllabel = document.querySelectorAll(".custom-coll-label");

Colllabel.forEach(label => {
   label.addEventListener("click", function(){
     this.parentElement.classList.toggle("active");
   });
});



//about page season slider
var swiper = new Swiper(".mySwiper", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
});

//about page season slider
 var swiper = new Swiper(".promySwiper", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });



// product page 
$(".template-page-sitemap .SectionHeader__Heading").each(function(a) {
     $(this).addClass("prd-itm-no-"+(a+0));
});
$(".template-page-sitemap .SectionHeader__Heading ~ ul").each(function(b) {
     $(this).addClass("prd-itm-no-"+(b+0));
});
$(".prd-itm-no-0").wrapAll('<div class="prd-wrap-col prd-0"></div>');
$(".prd-itm-no-1").wrapAll('<div class="prd-wrap-col prd-1"></div>');
$(".prd-itm-no-2").wrapAll('<div class="prd-wrap-col prd-2"></div>');
$(".prd-itm-no-3").wrapAll('<div class="prd-wrap-col prd-3"></div>');


//.header-section .header full-menu.full-menu ul li.menu-item-has-megamenu a.mega-menu__top-link

// Wishlist script
document.addEventListener("DOMContentLoaded", function () {
    updateWishlistButtons(); //  Update all buttons when the page loads
    syncWishlistOnProductPage(); //  Sync product page button color
    displayWishlist(); //  Show wishlist items
});

//  Toggle Wishlist (Add/Remove)
function toggleWishlist(button) {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const productData = {
        productTitle: button.getAttribute("data-title"),
        productImg: button.getAttribute("data-img"),
        productPrice: button.getAttribute("data-price"),
        productUrl: button.getAttribute("data-url"),
        variants: JSON.parse(button.getAttribute("data-variants")) || []
    };

    const existingIndex = wishlist.findIndex(item => item.productTitle === productData.productTitle);

    if (existingIndex !== -1) {
        wishlist.splice(existingIndex, 1); // Remove from wishlist
    } else {
        wishlist.push(productData); // Add to wishlist
    }

    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    updateWishlistButtons(); //  Update buttons across pages
    syncWishlistOnProductPage(); //  Ensure product page updates
    displayWishlist(); //  Refresh wishlist
}

//  Update All Wishlist Buttons
function updateWishlistButtons() {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const wishlistButtons = document.querySelectorAll(".wishlist-button");

    wishlistButtons.forEach(button => {
        const productTitle = button.getAttribute("data-title");
        const isInWishlist = wishlist.some(item => item.productTitle === productTitle);

        button.innerHTML = getWishlistButtonHTML(isInWishlist);

        // Add "added" class if the item is in the wishlist
        button.classList.toggle("added", isInWishlist);
    });

    //  Update Wishlist Count
    const wishlistCount = document.querySelector(".wishlist-count");
    if (wishlistCount) {
        wishlistCount.textContent = wishlist.length > 0 ? wishlist.length : "";
    }
}

//  Ensure Product Page Wishlist Icon Syncs
function syncWishlistOnProductPage() {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    const productPageButton = document.querySelector(".wishlist-button.product-page");

    if (!productPageButton) return;

    const productTitle = productPageButton.getAttribute("data-title");
    const isInWishlist = wishlist.some(item => item.productTitle === productTitle);

    productPageButton.innerHTML = getWishlistButtonHTML(isInWishlist);
    productPageButton.classList.toggle("added", isInWishlist);
}

//  Wishlist Button SVG & Text
function getWishlistButtonHTML(isInWishlist) {
    return isInWishlist
        ? `<svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fill="#E63946" d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/></svg>
            <p class="wishlist_text">In Your Wishlist</p>`
        : `<svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/></svg>
            <p class="wishlist_text">Not In Wishlist</p>`;
}

//  Display Wishlist on Wishlist Page
function displayWishlist() {
    const wishlistContainer = document.querySelector(".js-wishlistBlock");
    if (!wishlistContainer) return; // Stop execution if container not found

    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    wishlistContainer.innerHTML = wishlist.length > 0
        ? wishlist.map(item => `
            <li class="wishlist-product__list column">
            <product-card class="product-card text-left ff">
            <figure class="product-featured-image thb-hover">
       
                    <a href="${item.productUrl}" class="product-featured-image-link">
                        <img src="${item.productImg}" width="532" alt="${item.productTitle}">
                    </a>
                    
                    
                    
                    
                    <div class="cus-size-wrap">
                     <h4>Quick add+</h4>
                    <div class="product-size">
                      ${
                          item.variants && item.variants.length > 0
                          ? item.variants.map(variant => `
                              <span data-policy="${variant.inventory_policy}"
                                  data-qty="${variant.inventory_quantity || 0}" 
                                  data-id="${variant.id}" 
                                  class="cus-wishlist-btn btn sizebtn frequently-btn ${variant.available ? '' : 'sold-out'}">
                                  ${variant.title}
                              </span>
                          `).join('')
                          : `<span class="btn sizebtn frequently-btn sold-out">No variants available</span>`
                      }
                  </div>
                     </div>
                </figure>
                <div class="product-card-info">
                <div class="tit-price-wrap">
                        <a class="product-card-title" href="${item.productUrl}">${item.productTitle || "No Title Available"}</a>
                        <span class="price">
                        <ins>
                        <p>${item.productPrice || "Price Unavailable"}</p>
                        </ins>
                        </span>
                    </div>
                    
                    <button class="wishlist-remove btn btn-blk" onclick="removeFromWishlist('${item.productTitle}')">Remove</button>  
                    </div>
                </product-card>
            </li>
        `).join('')
        : "<div class='wishlist--empty'><p>Your wishlist is empty.</p></div>";

    //  Update wishlist count
    const wishlistCount = document.querySelector(".wishlist-count");
    if (wishlistCount) {
        wishlistCount.textContent = wishlist.length > 0 ? wishlist.length : "";
    }

   rebindCartEvents();

  // text update
  document.querySelectorAll('.cus-wishlist-btn').forEach(btn => {
  if (btn.textContent.trim() === 'Default Title') {
    btn.textContent = 'Add to cart';
  }
});
  
  
}




//  Remove Item from Wishlist
window.removeFromWishlist = function (productTitle) {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    wishlist = wishlist.filter(item => item.productTitle !== productTitle);
    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    updateWishlistButtons(); //  Update buttons on all pages
    syncWishlistOnProductPage(); //  Ensure product page updates
    displayWishlist(); //  Refresh wishlist
};


setTimeout(function () {
    let StartCount = $(".product .loox-rating").attr("data-rating") || "N/A"; // Fallback value if null/undefined
    if (StartCount !== "N/A") { // Ensure valid rating before appending
        $(".loox-rating-content").append(`<div class="loox-rating-label rating-count-cus"> (${StartCount}) </div>`);
    }
}, 3500);


// filter stock
// if(!document.querySelector('input[name="filter.v.availability"]:checked') && document.querySelector('input[name="filter.v.availability"]')){
//   document.querySelector('input[name="filter.v.availability"]').click();    
// }

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 1067) {
    document.querySelector(".custom-coll-wrap.active")?.classList.remove("active");
    document.querySelector(".custom-coll-wrap .thb-filter")?.removeAttribute("open");
  }
});













